export default __webpack_public_path__ + "static/media/react.540cbcd2.png";